/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { DataAccessService } from '@pmis3/data-access';

import { ISeaport } from '../models';

@Injectable()
export class SeaportPickerService {
  private readonly endpoint = 'schedule';
  private readonly path = 'searchSeaPorts';

    searchSeaPorts(searchText: string, take: number = 100): Observable<ISeaport[]> {
        return of([
            {
                id: 2,
                name: 'Qingdao Port',
                shortCode: 'CN QDG',
                locationTypeId: 1,
                locationTypeName: 'Port',
                // description: 'One of the largest ports in China located in Qingdao.',
                // isActive: true,
                // seq: 1
            },
        
            {
                id: 1,
                name: 'Yeosu Port',
                shortCode: 'KR YOS',
                locationTypeId: 1,
                locationTypeName: 'Port',
                // description: 'Major port city in South Korea, important for petrochemical exports.',
                // isActive: true,
                // seq: 2
            }]);
    }

}
